const ja_JP = {
  restartInterviewButton: "最初からやり直す",
  restartInterviewConfirmTitle: "新しいインタビューを始めますか？",
  restartInterviewConfirmDescription: "新しいインタビューを最初から始めます。これまでのインタビュー記録は保存されます。",
  restartInterviewCancel: "キャンセル",
  restartInterviewFailed: "インタビューをやり直せませんでした。しばらくしてからもう一度お試しください。",
  restartInterviewLimitReached: "インタビューの上限に達したため、新しく開始できません。",
  restartInterviewClosed: "このインタビューは終了したため、新しく開始できません。",
  restartInterviewCutoff: "参加期限を過ぎたため、新しく開始できません。",
  interviewLoading: "インタビューを読み込んでいます…",
  interviewLinkInvalid: "インタビューのリンクが無効です",
  interviewLoadFailed: "インタビューを読み込めませんでした。しばらくしてからもう一度お試しください。",
  interviewRetry: "再試行",
  saveInfoFailed: '情報を保存できませんでした。もう一度お試しください。',
  loadLatestInterviewFailed: '最新のインタビュー記録を読み込めませんでした。しばらくしてからもう一度お試しください。',
  interviewProgressSaved: 'インタビューの進行状況は失われません',
  previousStimulus: '前のコンセプト',
  nextStimulus: '次のコンセプト',
  expandStimulus: 'コンセプトを拡大',
  closeStimulusPreview: 'コンセプトのプレビューを閉じる',
  stimulusPreview: 'コンセプトのプレビュー',
  imageTooLarge: '画像のサイズは10 MB以下にしてください',
  imageFormatJpegPngOnly: 'PNG、JPEG、JPG形式の画像のみ対応しています',
  imageFilesOnly: '画像ファイルのみアップロードできます',
  imageUploadFailed: '画像をアップロードできませんでした。もう一度お試しください。',
  finalUploadFailed: 'ファイルをアップロードできませんでした。もう一度お試しください。',
  TitleTop: 'ご招待します！',
  HeardVoice: 'あなたの声を届けて特典を受け取ろう',
  Sophie: 'Avaと5～10分の気軽な会話',
  Sponsored: 'サンタクロース提供🎅',
  Chikkens: '短い会話を始めて特典を獲得',
  Dollars: 'あなただけのCHIMOJIとともに',
  Congrats: 'おめでとうございます！',
  Welcome: 'ようこそ',
  StartInterview: 'インタビュー開始',
  Submit: '送信',
  Stoprecording: '返信の停止',
  Aiinterviewer: 'インタビュー担当者',
  AiModeratedInterview: 'AIモデレーターによるインタビュー',
  TalkToAva: 'Ava と話す',
  microphoneAccessTitle: 'マイクへのアクセスを許可',
  microphoneAccessDescription: '自然な音声会話のために、Ava がマイクを使用します。',
  microphoneAllow: 'マイクを許可',
  microphoneNotNow: '今はしない',
  microphoneConnectedTitle: 'マイクに接続しました',
  microphoneConnectedDescription: '準備ができました。Ava は聞く準備ができています。',
  microphoneDeniedTitle: 'マイクの許可が必要です',
  microphoneDeniedDescription: 'ブラウザ設定でマイクを許可してから、もう一度お試しください。',
  microphoneTryAgain: '再試行',
  VoiceAnswer: '音声応答',
  TextAnswer: 'テキスト応答',
  StudyMainTitle: '実際の面接の前に、フィルタリングを行います',
  StudyMainTip: '残念ながら、このインタビューに参加することはできません',
  ThankYou: 'ありがとうございます。',
  Refresh: 'ページを更新してもこのチャットの進行状況は失われません',
  Carousel: 'インターネットの状況により若干の遅延が発生する場合があります',
  CheckOut: 'このようなインタビューも作ってみませんか？ ',
  Rewarded:
    '報酬を得たいなら、面接官はあなたについての情報を持っている必要があります ',
  InterviewerReward: 'これは面接官からの報酬です ',
  Register: '登録/サインイン',
  Insighteer: 'INSIGHTEER',
  Reward: '限定特典を獲得',
  CreatePassword: '登録を完了するにはパスワードを作成してください',
  Becoming: '私たちの一員になりましょう！',
  Password: 'パスワードを入力してください。',
  ChooseTopic: '興味のあるトピックを選択してください',
  Identity: '你是...',
  Awesome: 'Awesome!',
  Rocks: 'ROCKS',
  Followus: '私たちに従ってください',
  Unique:
    'あなただけの特別なCHIMOJIが、このインタビューとともにブロックチェーン上に記録されます',
  Next: '次のステップ',
  ViewRewards: '特典を見る',
  endMeg1: '音声再生を送信できるように、ここにメールアドレスを残してください',
  endMeg2:
    'このインタビューの作成者からインセンティブを受け取るには、ここにあなたの情報を残してください',
  endMeg3: 'このインタビューの作成者のためにここにあなたの情報を残してください',
  endMsg5: 'ここにあなたの情報を残してください ',
  endMsg6: 'MBTIテストの結果',
  Done: '提出する',
  Done1: '終了',
  GetIncentives: 'インセンティブを獲得',
  GetStartedFreeNow: '今すぐ無料で始める',
  UniqueChimojiNFT: 'ユニークなChimoji NFT',
  endMsg4: '独自のインタビューを作成したいですか?',
  ResumeInterview: 'インタビューを再開するにはクリックしてください',
  interviewPausedTitle: 'インタビューは一時停止中です',
  interviewPausedDescription: '進行状況は保存されています。準備ができたらいつでも再開できます。',
  resumeInterviewButton: 'インタビューを再開',
  pauseInterview: '一時停止',
  pauseInterviewConfirmTitle: 'インタビューを一時停止しますか？',
  pauseInterviewConfirmContent: '進捗は保存され、後でインタビューを再開できます。',
  pauseInterviewConfirmOk: '一時停止',
  pauseInterviewConfirmCancel: 'インタビューを続ける',
  poorConnection: '接続不良',
  connectionReconnectingTitle: '再接続しています…',
  connectionReconnectingDescription: 'このページを開いたままにしてください。Ava が接続を復旧しています。',
  connectionReconnectedTitle: '再接続しました',
  connectionReconnectedDescription: '接続が復旧しました。インタビューを続けます。',
  connectionDisconnectedTitle: '接続が切断されました',
  connectionDisconnectedDescription: 'インタビューの進行状況は保存されています。',
  refresh: 'ページを更新しても進捗状況は失われません',
  voiceSnapshot: '音声スナップショット',
  fromInterview: 'AIストーリーキュレーターのアヴァとのインタビューより',
  findMore: 'Chikka.aiでもっと知る',
  msg1: 'AVAと話して5分でMBTIをテストしましょう',
  speaking: 'あなたは話しています...',
  avaSpeaking: 'AVAは話しています...',
  avaListening: 'AVAは聞いています...',
  stimuliConversationWithAva: 'Ava と会話中です',
  stimuliReviewConcepts:
    '以下のコンセプトをよく確認し、Ava の質問に答えてください。',
  stimuliSwipeInstruction:
    '左右にスワイプして、すべてのコンセプトを表示してください。',
  stimuliFullscreenInstruction: '画像をダブルクリックすると全画面で表示できます。',
  finalUploadTitleFallback: 'ファイルをアップロード',
  finalUploadInstructionFallback:
    'インタビューを終了する前にファイルを追加してください',
  finalUploadTap: 'タップしてアップロード',
  finalUploadHelp:
    'あなたのファイルは体験をよりよく理解するのに役立ちます。',
  finalUploadLimit: '最大10ファイル',
  finalUploadSubmit: '送信',
  finalUploadSkip: 'スキップ',
  finalUploadWait: 'すべてのファイルのアップロード完了をお待ちください',
}
export default ja_JP
